import type { FirebaseApp } from 'firebase/app';

const KEY = 'fallback_to_server_sec';
const DEFAULT_SECONDS = 7;
let timeoutMs = DEFAULT_SECONDS * 1000;
let initialization: Promise<void> | undefined;

export function getFallbackTimeoutMs(): number {
    return timeoutMs;
}

export function parseFallbackTimeoutMs(seconds: number): number {
    // Reject invalid values and delays that would overflow browser timers.
    return Number.isFinite(seconds) && seconds > 0 && seconds <= 2147483
        ? Math.max(1, Math.round(seconds * 1000))
        : DEFAULT_SECONDS * 1000;
}

/** Fetch in the background; connection setup must also work offline. */
export function initializeTransferConfig(app: FirebaseApp): Promise<void> {
    return (initialization ??= (async () => {
        try {
            const sdk = await import('firebase/remote-config');
            if (!(await sdk.isSupported())) return;
            const config = sdk.getRemoteConfig(app);
            config.defaultConfig = {
                ...config.defaultConfig,
                [KEY]: DEFAULT_SECONDS,
            };
            config.settings.fetchTimeoutMillis = 5000;
            config.settings.minimumFetchIntervalMillis =
                process.env.NODE_ENV === 'development' ? 0 : 60 * 60 * 1000;
            await sdk.ensureInitialized(config);
            timeoutMs = parseFallbackTimeoutMs(sdk.getNumber(config, KEY));
            await sdk.fetchAndActivate(config);
            timeoutMs = parseFallbackTimeoutMs(sdk.getNumber(config, KEY));
        } catch {
            // Keep the cached value, or the in-app default on first launch.
        }
    })());
}
